import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import ValidationError from "~/Components/Forms/ValidationError";
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";
import placeholder from "~/assets/placeholder-image.svg";
import AdminImageUploader from "~/Admin/AdminImageUploader/AdminImageUploader";
import Translated from "~/Admin/AdminMultilang/Translated";

const AdminEventTracksideItem = ({match, event, experience, onChange, onDelete, ...props}) => {

    const defaultForm = {
        name: experience?.name || '',
        description: experience?.description || '',
        info: experience?.info || '',
        translations: experience?.translations || {}
    };

    const [form, setForm] = useState(defaultForm);

    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setForm({...form, [name]: value});
    };

    const handleDelete = () => {
        adminHttp
            .delete('/events/' + event.id + '/experiences/' + experience.id)
            .then(res => {
                setError(null);
                setMessage('');

                if (onDelete) {
                    onDelete();
                }

            }).catch((error) => {
            setMessage(null);
            setError(error.response?.data);
        });
    }

    const handleSubmit = () => {
        adminHttp
            .put('/events/' + event.id + '/experiences/' + experience.id, form)
            .then(res => {
                setError(null);
                setMessage('Saved successfully!');

                if (onChange) {
                    onChange();
                }

            }).catch((error) => {
            setMessage(null);
            setError(error.response?.data);
        });
    };

    return (
        <div>
            {message && (
                <div className="alert alert-success" role="alert">
                    {message}
                </div>
            )}

            {error && (
                <div className="alert alert-danger" role="alert">
                    {error.message || "Error saving event!"}
                </div>
            )}

            <div className="form-group required">
                <label className="d-block">Name</label>

                <Translated translations={form.translations}
                            onChanged={(values) => setForm({...form, translations: values})}>
                    <input
                        onChange={handleChange}
                        value={form.name}
                        name="name"
                        className="form-control"/>
                </Translated>

                <ValidationError errors={error?.errors} name="name"/>

            </div>

            <div className="form-group required">
                <label className="d-block">Description Copy</label>
                <small className="d-block">Please provide a description of the experience guests will get access
                    to.</small>

                <Translated translations={form.translations}
                            onChanged={(values) => setForm({...form, translations: values})}>
                    <textarea
                        onChange={handleChange}
                        value={form.description}
                        rows={10}
                        name="description"
                        className="form-control"/>
                </Translated>

                <ValidationError errors={error?.errors} name="description"/>
            </div>

            <div className="form-group required">
                <label className="d-block">Useful information</label>
                <small className="d-block">Please provide key information related to the guests’ experience.</small>

                <Translated translations={form.translations}
                            onChanged={(values) => setForm({...form, translations: values})}>
                    <textarea
                        onChange={handleChange}
                        value={form.info}
                        rows={10}
                        name="info"
                        className="form-control"/>
                </Translated>

                <ValidationError errors={error?.errors} name="info"/>
            </div>


            <div className="form-group">
                <label className="d-block">Experience Image</label>

                <img className="img-thumbnail mb-2 d-block" src={experience.image?.download_url || placeholder} />

                <AdminImageUploader
                    image={experience.image}
                    onChanged={onChange}
                    className="text-primary cursor-pointer d-block">Edit Experience Image</AdminImageUploader>
            </div>

            <button
                onClick={handleSubmit}
                className="btn btn-primary text-cta float-right btn-sm">
                Save Experience
            </button>

            <ConfirmedButton
                onClick={handleDelete}
                className="btn btn-danger text-cta float-right mr-3 btn-sm">
                Delete Experience
            </ConfirmedButton>

        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventTracksideItem);
